import React from "react";
import "./EnquiryForm.css";
import FooterSection from "../FooterSection/FooterSection";
import logo1 from "../../assets/logo1.png";
const EnquiryForm = () => {
  return (
    <div className="travel-main-container">
      {/* ================= NAVBAR ================= */}
      <div className="navbar">
        <div className="nav-left">
          <div className="logo-circlee">
              <img src={logo1} alt="logo-zikrme" className="zikrme-logo-image"/>
          </div>
          <h2>Travel Enquiry</h2>
        </div>

        <div className="nav-right">
          <span>Home</span>
          <span>About</span>
          <span>Contact</span>

          <div className="search-boxx">
            <input type="text" placeholder="Search in site" />
            <span className="search-icon">🔍</span>
          </div>
        </div>
      </div>

      {/* ================= PAGE HEADING ================= */}
      <div className="heading-section">
        <h1>Travel Package Enquiry Form</h1>
      </div>

      {/* ================= FORM SECTION ================= */}
      <div className="form-section">
        <div className="section-title">
          <span>Personal Details</span>
        </div>

        <div className="form-row">
          <label>Full Name *</label>
          <input type="text" placeholder="Enter Your Name" />
        </div>

        <div className="form-row">
          <label>Email Address *</label>
          <input type="text" placeholder="Enter Your Email id" />
        </div>

        <div className="form-row">
          <label>Mobile Number *</label>
          <input type="text" placeholder="Enter Your Mobile Number" />
        </div>

        <div className="form-row">
          <label>City / Location</label>
          <input type="text" placeholder="Enter Your City" />
        </div>
      </div>
      {/* ================= DASHED LINE ================= */}
      <div className="dashed-line"></div>

      {/* ================= TRIP DETAILS SECTION ================= */}
      <div className="trip-section">
        <div className="section-title">
          <span>Trip Details</span>
        </div>

        {/* Destination */}
        <div className="form-row">
          <label>Destination</label>
          <input type="text" placeholder="Enter Destination" />
        </div>

        {/* Travel Type */}
        <div className="form-row travel-type-row">
          <label>Travel Type</label>

          <div className="checkbox-column">
            <div className="checkbox-item">
              <input type="checkbox" />
              <span>Solo</span>
            </div>

            <div className="checkbox-item">
              <input type="checkbox" />
              <span>Couple</span>
            </div>

            <div className="checkbox-item">
              <input type="checkbox" />
              <span>Family</span>
            </div>

            <div className="checkbox-item">
              <input type="checkbox" />
              <span>Friends/Group</span>
            </div>

            <div className="checkbox-item">
              <input type="checkbox" />
              <span>Corporate</span>
            </div>
          </div>
        </div>

        {/* Number of Travelers */}
        <div className="form-row travelers-row">
          <label>Number of Travelers</label>

          <div className="travelers-inputs">
            <div className="traveler-input">
              <span>Adults</span>
              <input type="text" placeholder="Enter no. Adults" />
            </div>

            <div className="traveler-input">
              <span>Children (if any)</span>
              <input type="text" placeholder="Enter no. Adults" />
            </div>
          </div>
        </div>
      </div>
      {/* ================= DASHED LINE ================= */}
      <div className="dashed-line"></div>

      {/* ================= TRAVEL PLAN SECTION ================= */}
      <div className="travel-plan-section">
        <div className="section-title">
          <span>Travel Plan</span>
        </div>

        {/* Preferred Travel Month */}
        <div className="form-row months-row">
          <label>Preferred Travel Month</label>

          <div className="months-container">
            <div className="month-item">
              <input type="checkbox" /> January
            </div>
            <div className="month-item">
              <input type="checkbox" /> February
            </div>
            <div className="month-item">
              <input type="checkbox" /> March
            </div>
            <div className="month-item">
              <input type="checkbox" /> April
            </div>
            <div className="month-item">
              <input type="checkbox" /> May
            </div>
            <div className="month-item">
              <input type="checkbox" /> June
            </div>

            <div className="month-item">
              <input type="checkbox" /> July
            </div>
            <div className="month-item">
              <input type="checkbox" /> August
            </div>
            <div className="month-item">
              <input type="checkbox" /> September
            </div>
            <div className="month-item">
              <input type="checkbox" /> October
            </div>
            <div className="month-item">
              <input type="checkbox" /> November
            </div>
            <div className="month-item">
              <input type="checkbox" /> December
            </div>
          </div>
        </div>

        {/* Preferred Travel Dates */}
        <div className="form-row date-row">
          <label>Preferred Travel Dates (From – To)</label>

          <div className="date-container">
            <input type="date" />
            <input type="date" />
          </div>
        </div>
      </div>

      {/* ================= DASHED LINE ================= */}
      <div className="dashed-line"></div>

      {/* ================= SECOND TRAVEL PLAN SECTION ================= */}
      <div className="travel-plan-section">
        <div className="section-title">
          <span>Travel Plan</span>
        </div>

        <div className="budget-section">
          <p>Select Your Budget Range</p>
          <button className="budget-btn">Budget Range</button>
        </div>
      </div>
      {/* ================= PACKAGE PREFERENCES ================= */}
      <div className="dashed-line"></div>
      <div className="package-section">
        <div className="section-title">
          <span>Package Preferences</span>
        </div>

        {/* Accommodation Type */}
        <div className="form-row horizontal-options">
          <label>Accommodation Type</label>

          <div className="options-row">
            <div className="option-item">
              <input type="checkbox" />
              <span>Budget</span>
            </div>

            <div className="option-item">
              <input type="checkbox" />
              <span>Standard</span>
            </div>

            <div className="option-item">
              <input type="checkbox" />
              <span>Premium</span>
            </div>

            <div className="option-item">
              <input type="checkbox" />
              <span>Luxury</span>
            </div>
          </div>
        </div>

        {/* Meal Preference */}
        <div className="form-row horizontal-options">
          <label>Meal Preference</label>

          <div className="options-row">
            <div className="option-item">
              <input type="checkbox" />
              <span>Breakfast Only</span>
            </div>

            <div className="option-item">
              <input type="checkbox" />
              <span>Breakfast + Dinner</span>
            </div>

            <div className="option-item">
              <input type="checkbox" />
              <span>All Meal</span>
            </div>
          </div>
        </div>

        {/* Transport */}
        <div className="form-row horizontal-options">
          <label>Are you Required Transport?</label>

          <div className="options-row">
            <div className="option-item">
              <input type="checkbox" />
              <span>Yes</span>
            </div>

            <div className="option-item">
              <input type="checkbox" />
              <span>No</span>
            </div>
          </div>
        </div>
      </div>

      {/* ================= DASHED LINE ================= */}
      <div className="dashed-line"></div>

      {/* ================= ACTIVITIES SECTION ================= */}
      <div className="activities-section">
        <div className="section-title">
          <span>Activities/Interest</span>
        </div>

        <div className="activities-grid">
          <div className="option-item">
            <input type="checkbox" />
            <span>Sightseeing</span>
          </div>

          <div className="option-item">
            <input type="checkbox" />
            <span>Adventure</span>
          </div>

          <div className="option-item">
            <input type="checkbox" />
            <span>Honeymoon/Romantic</span>
          </div>

          <div className="option-item">
            <input type="checkbox" />
            <span>Pilgrimage</span>
          </div>

          <div className="option-item">
            <input type="checkbox" />
            <span>Nature & Relaxation</span>
          </div>

          <div className="option-item">
            <input type="checkbox" />
            <span>Food & Culture</span>
          </div>
        </div>
      </div>
      <div className="additional-container">
        <div className="dashed-line"></div>

        <div className="heading-wrapper">
          <h2 className="heading">Additional Requirements</h2>
        </div>

        <div className="form-row">
          <label className="label">Any Special request</label>
          <textarea
            className="textarea"
            placeholder="Enter Your Request/Customization"
          ></textarea>
        </div>
      </div>
      <div className="dashed-line"></div>
      <div className="submit-container">
        <div className="button-wrapper">
          <button className="submit-btn">Submit</button>
        </div>

        <div className="note-section">
          <p className="note-title">Note:</p>
          <p className="note-text">
            Our team will contact you with the best suitable travel package.
          </p>
        </div>
      </div>
      <FooterSection />
    </div>
  );
};

export default EnquiryForm;
